import accountVoices from './accountVoices.json';
import activities from './activities.json';
import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import aiIgnoredNumbers from './aiIgnoredNumbers.json';
import aiStudio from './aiStudio.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import billing from './billing.json';
import claudeOauth from './claudeOauth.json';
import bulkActions from './bulkActions.json';
import calendar from './calendar.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import emailTemplatesMgmt from './emailTemplates.json';
import chatlist from './chatlist.json';
import chatRooms from './chatRooms.json';
import companies from './companies.json';
import tasks from './tasks.json';
import workspace from './workspace.json';
import vigia from './vigia.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import contactImport from './contactImport.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customFields from './customFields.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import crmMetrics from './crmMetrics.json';
import dealReports from './dealReports.json';
import deals from './deals.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import kanban from './kanban.json';
import meetings from './meetings.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import lossReasonsMgmt from './lossReasonsMgmt.json';
import macros from './macros.json';
import salesGoalsMgmt from './salesGoalsMgmt.json';
import mainDashboard from './mainDashboard.json';
import marketing from './marketing.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import revenda from './revenda.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import teamsSettings from './teamsSettings.json';
import tour from './tour.json';
import whatsappTemplates from './whatsappTemplates.json';
import contentTemplates from './contentTemplates.json';
import product from './product.json';
import products from './products.json';
import productsCatalog from './productsCatalog.json';
import appointments from './appointments.json';
import notes from './notes.json';
import kanbanReports from './kanbanReports.json';
import flowbuild from './flowbuild.json';
import forms from './forms.json';
import growthLinks from './growthLinks.json';
import aiAgents from './agents.json';
import leadProspector from './leadProspector.json';
import metaAds from './metaAds.json';
import prospecting from './prospecting.json';
import crmHome from './crmHome.json';
import liaAgents from './liaAgents.json';
import multipleFunnels from './multipleFunnels.json';
import copilot from './copilot.json';
import configAssistant from './configAssistant.json';
import callDevices from './callDevices.json';
import social from './social.json';
import turmas from './turmas.json';

export default {
  ...accountVoices,
  ...activities,
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...aiIgnoredNumbers,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...billing,
  ...claudeOauth,
  ...bulkActions,
  ...calendar,
  ...campaign,
  ...cannedMgmt,
  ...emailTemplatesMgmt,
  ...chatlist,
  ...chatRooms,
  ...companies,
  ...tasks,
  ...workspace,
  ...vigia,
  ...components,
  ...contact,
  ...contactFilters,
  ...contactImport,
  ...conversation,
  ...csatMgmt,
  ...customFields,
  ...customRole,
  ...datePicker,
  ...crmMetrics,
  ...dealReports,
  ...deals,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...kanban,
  ...meetings,
  ...labelsMgmt,
  ...login,
  ...lossReasonsMgmt,
  ...macros,
  ...salesGoalsMgmt,
  ...mainDashboard,
  ...marketing,
  ...report,
  ...resetPassword,
  ...revenda,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...teamsSettings,
  ...tour,
  ...whatsappTemplates,
  ...contentTemplates,
  ...product,
  ...products,
  ...productsCatalog,
  ...appointments,
  ...notes,
  ...kanbanReports,
  ...flowbuild,
  ...forms,
  ...growthLinks,
  ...aiAgents,
  ...leadProspector,
  ...metaAds,
  ...prospecting,
  ...crmHome,
  ...liaAgents,
  ...multipleFunnels,
  ...copilot,
  ...configAssistant,
  ...callDevices,
  ...social,
  ...aiStudio,
  ...turmas,
};
